/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

const cacheableUrls = ['/collections'];

@Injectable({
    providedIn: 'root'
})
export class CacheInterceptorService implements HttpInterceptor {
    private cache: Map<string, HttpResponse<any>> = new Map();

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Cache all collections requests
        const isCacheable = cacheableUrls.some((x) => request.url.includes(x));

        if (!isCacheable) {
            return next.handle(request);
        }

        // Check if the response is cached
        const cachedResponse = this.cache.get(request.url);
        if (cachedResponse) {
            return of(cachedResponse.clone());
        }

        // Forward the request to the next handler
        return next.handle(request).pipe(
            tap((event) => {
                // Cache the response for future requests
                if (event instanceof HttpResponse) {
                    this.cache.set(request.url, event.clone());
                }
            })
        );
    }
}
